export default __webpack_public_path__ + "static/media/desktop-step5.272f631e.png";